<template>
    <div>
        <card-toolbar>
            <button @click="$openCard('new-task', {entityType, entityId}, card)"><i class="fas fa-plus mr-2"/>New Task</button>
        </card-toolbar>
        <card-list>
            <subheader-list-item icon="fa-tasks" title="Open Tasks" :badge="openTasks.length"/>
            <task-list-item
                :card="card"
                :task="task"
                v-for="task in openTasks"
                :key="task.id"
                :active="(child && child.definition.component === 'edit-task') && child.props.taskId === task.id.toString()"
                @click="$openCard('edit-task', {taskId: task.id}, card)"
            />
            <container-list-item padded v-if="!openTasks.length">
                <p class="has-text-grey is-size-7 my-2">No open tasks.</p>
            </container-list-item>
            <template v-if="completedTasks.length">
                <subheader-list-item icon="fa-check" title="Completed" :badge="completedTasks.length"/>
                <task-list-item
                    :card="card"
                    :task="task"
                    v-for="task in completedTasks"
                    :key="task.id"
                    :active="(child && child.definition.component === 'edit-task') && child.props.taskId === task.id.toString()"
                    @click="$openCard('edit-task', {taskId: task.id}, card)"
                />
            </template>
        </card-list>
    </div>
</template>

<script>
    import {client as http} from '../http_client';
    import CardToolbar from "../TIER/components/CardToolbar";
    import CardList from "../TIER/components/CardList";
    import SubheaderListItem from "../TIER/components/SubheaderListItem";
    import ContainerListItem from "../TIER/components/ContainerListItem";
    import TaskListItem from "@/components/TaskListItem";

    export default {
        name: 'EntityTasksPane',
        components: {TaskListItem, ContainerListItem, SubheaderListItem, CardList, CardToolbar},
        props: ['card', 'child', 'entityType', 'entityId'],
        data: function () {
            return {
                tasks: []
            }
        },
        computed: {
            openTasks: function () {
                return this.tasks.filter(t => t.complete !== 1);
            },
            completedTasks: function () {
                return this.tasks.filter(t => t.complete === 1);
            }
        },
        methods: {
            loadTasks: function (force) {
                if (!this.entityId) return;
                http.get(`/api/tasks/entity/${this.entityType}/${this.entityId}`, {force}).then(response => {
                    this.tasks = response.data;
                    // The host card shows "open / completed" on its Tasks tab.
                    this.$emit('count', this.openTasks.length);
                    this.$emit('completed', this.completedTasks.length);
                });
            },
            reload: function () {
                this.loadTasks(true);
            }
        },
        watch: {
            entityId: function () {
                this.loadTasks(true);
            },
            // When a child card (new-task / edit-task) closes or changes, the
            // list is likely stale -- panes live inside the host card, so they
            // can't be targeted by $reloadCard like standalone cards.
            child: function () {
                this.loadTasks(true);
            }
        },
        mounted() {
            this.loadTasks();
        }
    };
</script>
